import React from "react";
import { Stack } from "@chakra-ui/react";
import SmileSignupLeftContentView from "./SmileSignupLeftContentView";
import { SmileSignUpSteps } from "../../..";

const SmileSignupLeftView = ({ step }: { step: SmileSignUpSteps }) => {
  return (
    <Stack color="white" align="center" width="100%">
      <SmileSignupLeftContentView step={step} />
    </Stack>
  );
};

export default SmileSignupLeftView;
